export default {"src":"/_next/static/media/instagram.2b6eb1b0.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};